import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

// Language detection logic
const detectLanguage = () => {
  // Attempt to get the language from localStorage
  const storedLang = localStorage.getItem('lang')

  if (storedLang && ['en', 'fr'].includes(storedLang)) {
    return storedLang // Return the stored language if valid
  }
  const browserLang = navigator.language.split('-')[0]
  const supportedLanguages = ['en', 'fr'] // You can add more languages here
  // If the browser language is supported, return it; else, default to 'en'
  return supportedLanguages.includes(browserLang) ? browserLang : 'en'
}

const i18n = new VueI18n({
  // locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  locale: detectLanguage(), // Set the default language based on the browser
  // fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: loadLocaleMessages()
})

export default i18n
